import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslocoService } from '@ngneat/transloco';

import Utils from 'src/app/utils';

import timezones from 'timezones-list';

declare var require: any;

@Component({
  selector: 'app-worker-add',
  templateUrl: './worker-add.component.html',
  styleUrls: ['./worker-add.component.scss']
})
export class WorkerAddComponent implements OnInit {

  worker: any;
  id?: number;
  check_in_times: { value: number; name: string }[] = [];
  alert_times = Utils.getAlertTimes();


  formGroup:any;

  submitted = false;
  submitting = false;

  get f(): { [key: string]: AbstractControl } {
    return this.formGroup.controls;
  }

  countryListArray  = Utils.getCountries();
  timezoneListArray = timezones;

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService, public transloco: TranslocoService) {

    this.check_in_times = Utils.getCheckinTimes(this.okService.settings?.id);

    let check_in_freq = null;
    if(!this.okService.features.timer){
      check_in_freq = 6000;
    }

    this.formGroup = new FormGroup({
      name: new FormControl('',[Validators.required]),
      email: new FormControl('',[Validators.email]),
      phone: new FormControl('',[]),
      // cell: new FormControl('',[]),
      country: new FormControl(null,[]),
      timezone: new FormControl(null,[]),
      check_in_freq: new FormControl(check_in_freq,[]),
      // call_alert: new FormControl(0,[]),
      // sms_alert: new FormControl(0,[]),
      monitors: new FormControl([],[]),
      groups: new FormControl([],[]),
      vehicle_id: new FormControl(null,[]),
      device: new FormControl('Smartphone',[Validators.required]),
      welcome: new FormControl(true,[]),
      sync_group: new FormControl(true,[]),
      learning: new FormControl(this.okService.hasFeature('learning_center'),[]),

    })

    if(this.okService.settings.arc_on){
      this.formGroup.setControl('email',new FormControl('',[Validators.email,Validators.required])),
      this.formGroup.setControl('phone',new FormControl('',[Validators.required]))
    }


   }


  ngOnInit(): void {

  }

  ngAfterViewInit()	: void {
    Utils.setupPopover();
  }

  submitForm(){
    if(this.submitting){
      return false;
    }

    this.submitted = true;

    if (
      this.formGroup.valid
      ) {
        let values = this.formGroup.value
        //console.log(values);

        this.submitting = true;

        this.okService.post("workers",values)
        .subscribe({
          next: (data) => {
            this.worker = data.body;

            //console.log("worker",this.worker);
            let id = this.worker.id;
            // this.okService.setAlert("The worker has been added","success");

            this.router.navigateByUrl("/mgmt/worker/"+id);
          },
          error: () => {
            this.submitting = false;
          }
        });

      }

    return false;
  }

  setDevice(device:string){

    this.formGroup.patchValue({
      device: device
    });
  }

}
